
/**
 * Javascript lié au formulaire "jeux-concours"
 * Utilise Form.js, Global.js, Autocomplete-google.js
 */

 import './form';


(function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude, { jeux_concours : {
                
        /**
         * Initialisation du formulaire Jeux concours
         */
        InitJeuxConcours() {
            
            // Pose le cookie du partenaire (doit être fait obligatoirement en JS car lorsque la page est en cache avec nginx ou fasterize le cookie n'est plus posé)
            if(jQuery("#jeux-concours[data-partner]").length>0) {
              Completude.SetCookie('partner', jQuery("#jeux-concours").data("partner"),365)             
            }

            // Active la validation sur le formulaire
            this.formJeux = Completude.SetFormValidation(jQuery('#jeux-concours-form'));
            // Active la gestion des étapes (library Steps.js)
            this.steps = new Steps({
                steps: '[data-step-index]',
                progress : '.progress-step',
                container: document.querySelector('#jeux-concours'),
                backNavigator : true
            });
            var self = this;
                      
            
            // Validation de l'étape 1
            jQuery("#jeux-concours-form-step1-btn").on("click", function() {
                    Completude.jeux_concours.CheckStep1();
            });             
            // Validation de l'étape 2
            jQuery("#jeux-concours-form-step2-btn").on("click", function() {
              Completude.jeux_concours.CheckStep2();
            });             
            // Retour step1
            jQuery("#jeux-concours-form-step2-back").on("click", function() {
              self.steps.prev();
            });           

        },

        /**
         * Clic sur le bouton "suivant" de l'étape 1
         */
        CheckStep1() {
            var self = this;            
            if (self.formJeux.validate('step1')) {
                                                               
              // L'étape 1 est valide
              // on fait une requete Ajax pour savoir si la commune est desservie
              jQuery("#etape1>div:first-child").loading(
              jQuery.ajax({
                  url: disko_ajax_object.ajaxurl,
                  type: 'post',
                  data: {
                    'action': 'wp_est_desservie',
                    'Latitude'       : window.autocomplete.localisation.lat,
                    'Longitude'       : window.autocomplete.localisation.lng,
                    'Ville'      : window.autocomplete.localisation.city                   
                  },
                  success: function (response) {
                    self.Desservie = JSON.parse(response.data);
                    if (!self.Desservie) {
                      // Masque le téléphone 
                      jQuery("#jeux-concours").find('[data-hideifnonsesservie]').hide();
                      jQuery('#devis').prop('checked',false);
                      jQuery('#phone').parsley().reset();

                    } else {
                      // Affiche le téléphone
                      jQuery("#jeux-concours").find('[data-hideifnonsesservie]').show();
                    }
                    // Passe à l'étape suivante
                    self.steps.next();
                    w.Completude.TagManager("Jeux-Concours","Etape2");
                  },
                  error: function (data) {
                    console.log('Erreur…');
                    self.Desservie = true;
                  }
                }).promise());
                
            } 
        },

        /**
         * Clic sur le bouton "Envoyer" de l'étape 2         
         */
        CheckStep2() {
          var self = this;
          if (self.formJeux.validate()) {
              // Post des données du jeux concours
              
              var postData = Object.assign({
                'action': 'wp_jeux_concours',
                'Latitude': window.autocomplete.localisation.lat,
                'Longitude': window.autocomplete.localisation.lng,
                'Ville': window.autocomplete.localisation.city,
                'CodePostal': window.autocomplete.localisation.postalCode,
                'Adresse': window.autocomplete.localisation.address,
                'DemandeDevis' : jQuery('#devis').prop("checked"),
                'Telephone' : jQuery('#phone').val(),
                'Email' : jQuery('#field-email').val(),
                'AccordEMail' : jQuery('#field-info').prop("checked"),
                'Nom' : jQuery('#field-lastname').val(),                  
                'IdClasse' : jQuery('#field-class').val() ,
                'CodePartenaire' : jQuery("#jeux-concours").data("partner"),
              }, Completude.GetGlobalUtmFields());

              jQuery("#etape2>div:first-child").loading(
                jQuery.ajax({
                url: disko_ajax_object.ajaxurl,
                type: 'post',
                data: postData,
                success: function (response) {
                  // Affiche la confirmation
                  self.steps.next();
                  w.Completude.TagManager("Jeux-Concours","Confirmation");
                  jQuery("#jeux-concours").after(jQuery(response));
                },
                error: function (data) {
                  //console.log('Erreur…');                  
                }
              }));
            }

        }
    }});       
})(window);

jQuery(function() {
     if (jQuery("#jeux-concours").length>0) {
        window.Completude.jeux_concours.InitJeuxConcours();         
     }
});





